var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.368 8.08V8.896H26.56V12.064H20.128C19.84 14.272 19.2 16 18.208 17.248C17.248 18.496 15.84 19.392 13.984 19.936C12.16 20.48 9.728 20.752 6.688 20.752V24.544C6.688 28.864 8.576 31.024 12.352 31.024C16.064 31.024 17.92 28.944 17.92 24.784H21.952C21.92 27.984 21.072 30.4 19.408 32.032C17.744 33.664 15.376 34.48 12.304 34.48C9.136 34.48 6.72 33.6 5.056 31.84C3.424 30.08 2.608 27.616 2.608 24.448V17.68C6.256 17.68 8.944 17.568 10.672 17.344C12.432 17.088 13.712 16.576 14.512 15.808C15.312 15.008 15.824 13.76 16.048 12.064H0.448V8.896H16.24V8.032V3.712H0.448V0.495999H26.56V3.712H20.368V8.08Z",
    fill: "#602EF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/amount.ebb2109fd9c30b9c40d61f6aa175809b.svg";
export { ForwardRef as ReactComponent };